import { render, staticRenderFns } from "./CategoriseSelectAnswer.vue?vue&type=template&id=221bb3b6&scoped=true&"
import script from "./CategoriseSelectAnswer.vue?vue&type=script&lang=js&"
export * from "./CategoriseSelectAnswer.vue?vue&type=script&lang=js&"
import style0 from "./CategoriseSelectAnswer.vue?vue&type=style&index=0&id=221bb3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bb3b6",
  null
  
)

export default component.exports